import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { ActionsService } from './services/actions.service';
import { RequestsService } from './services/requests.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'workspace-resource-provisioner-frontend';

  get headerVisible() {
    return !environment.noHeaderPaths.includes(window.location.pathname);
  }

  constructor(
    public translate: TranslateService,
    private readonly actionService: ActionsService,
    private readonly requestService: RequestsService
  ) {
    // Register translation languages
    translate.addLangs(['en', 'it']);
    // Set default language
    translate.setDefaultLang('it');
    if (this.headerVisible) {
      this.actionService.getAllPendingActions();
      this.requestService.getAllPendingRequests();
    }
  }
}
